/*
|--------------------------------------------------------------------------
| Utilities: Promowiz
|--------------------------------------------------------------------------
*/
__gh__webApp.utilities.promowiz = {
	"init":function(){
		var currentDomain = __gh__coreData.siteData.baseURL;
		// remove .load for #header-main-promo
	}
};